<template>
  <div class="container-fluid right_wrapper">
    <DspListFilter></DspListFilter>
    <div
        v-if="showLoader"
        class="spinner-border"
        style="margin: auto; display: block; margin-top: 60px"
      ></div>
      <div v-else>
        <DspTagListGrid class="table_wrap"/>
      </div>

    <DspTagListFooter class="main_footer_wrap" v-if="showDspRows"/>
</div>
</template>

<script>
import DspListFilter from "@/components/dsp-tags/DspListFilter";
import DspTagListFooter from "./DspTagListFooter.vue";
import DspTagListGrid from "./DspTagListGrid.vue";

export default {
    components: {
      DspListFilter,
      DspTagListFooter,
      DspTagListGrid
    },
    mounted() {
        this.$store.dispatch("callAnalytics", {
            data: window.location.href,
            this: this,
            type: "getDspTags",
        })
    },
    computed: {
      showDspRows: {
        set(val) {
          this.$store.state.showDspRows = val;
        },
        get() {
          return this.$store.state.showDspRows;
        },
      },
      showLoader: {
        get() {
          return this.$store.getters["getShowLoader"];
        },
      },
      
    },
}
</script>
<style>
.advertiser_id_col {
  font-size: small;
  font-weight: bold;
  font-style: italic;
}
.order_id_col {
  font-size: small;
  font-weight: bold;
  font-style: italic;
}
.dsp_row_count {
  float: right;
  padding: 15px;
}

</style>

<style lang="scss">
.right_wrapper {
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  .inp_header {
    box-sizing: border-box;
    height: 43px;
    width: 220px;
    border: 1px solid #979797;
    border-radius: 6px;
    background-color: #fff;
  }
  .main_footer_wrap {
    border: none;
    height: 80px;
    width: 100%;
    overflow: hidden;
    padding: 10px;
  }
  .bulk_action {
    position: fixed;
    bottom: 105px;
    right: 30px;
    height: 43px;
    width: 146px;
    border-radius: 21.5px;
    background-color: #ffbf3f;
    padding: 11px 8px 8px 14px;
    cursor: pointer;
    .text {
      height: 19px;
      color: #333333;
      font-family: "Nunito Sans";
      font-size: 14px;
      font-weight: bold;
      float: left;
      padding-right: 7px;
    }
  }
  .table_wrap {
    // margin-top: 15px;
    height: calc(100vh - 155px);
    width: 100%;
    overflow: auto;
    &.no_footer{
      height: calc(100vh - 75px) !important;
    }
    &.extra_bar{
      height: calc(100vh - 215px) !important;
    }
    &.extra_component{
      height: calc(100vh - 305px) !important
    }

    .table thead {
      background-color: white;
      top: 0;
      z-index: 1;
    }
    .table thead th {
      border: 0px !important;
      color: #333333;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 900;
      letter-spacing: -0.07px;
      line-height: 19px;
    }
    .table tbody td {
      border: 0px !important;
      color: #333333;
      font-family: Roboto;
      font-size: 16px;
      letter-spacing: -0.07px;
      line-height: 23px;
      word-wrap: break-word;
    }
    .table tbody tr.even {
      background-color: #fafafa;
    }
    .table tbody tr:hover {
      background-color: white;
    }
    .table tbody tr.even:hover {
      background-color: #fafafa;
    }
    .table tbody td{
      vertical-align: top !important;
      .row-add-edit{
        padding-top:3px;
        max-width:10px;
        .item-add-edit{
          display: block !important;
          opacity: 0.5 ;
        }
        .item-add-edit:hover{
          opacity: 1 !important;
        }
      }
      .label-info{
        background-color: #5bc0de;
      }
      .label {
        display: inline;
        padding: 0.2em 0.6em 0.3em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 0.25em;
      }
    }
    .bulk_action {
      height: 43px;
      width: 146px;
      border-radius: 21.5px;
      background-color: #ffbf3f;
    }
  }
}
</style>
